// extracted by mini-css-extract-plugin
module.exports = {"logo":"ModalLogo_logo__2X68B","logoWrapper":"ModalLogo_logoWrapper__3j11S"};